import React from 'react';

// THE INLINE BADGE from STYLE.md ("Badges & Status Chips" → "Inline badge"), as a component rather than
// a fifth hand-rolled copy of the same four CSS declarations.
//
// The variants are exactly the four the style guide names; there is no fifth, and a caller that wants a
// different colour wants one of these four or a different control. Sizes and radius are fixed for the
// same reason — a badge that is slightly bigger on one screen is not a decision anybody made.
const VARIANTS = {
    green: { color: '#166534', background: '#dcfce7' },
    blue:  { color: '#4338ca', background: '#eef2ff' },
    red:   { color: '#b91c1c', background: '#fee2e2' },
    amber: { color: '#92400e', background: '#fef3c7' },
};

const Badge = ({ variant = 'blue', title, children }) => (
    <span
        title={title}
        style={{
            ...(VARIANTS[variant] || VARIANTS.blue),
            fontSize: '0.72rem',
            fontWeight: 600,
            borderRadius: 20,
            padding: '0.1rem 0.45rem',
            whiteSpace: 'nowrap',
        }}
    >
        {children}
    </span>
);

export default Badge;
